import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'

// TODO i18n support

TimeAgo.addLocale(en)

export default new TimeAgo('en-US')
